import React from 'react';
import './NoRecordFound.css';

const NoRecordFound = ({ message = 'No records found.' }) => (
  <div className="no-record-found-container">
    <div className="no-record-svg-wrapper">
      <svg
        width="140"
        height="140"
        viewBox="0 0 140 140"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="no-record-svg"
      >
        <ellipse
          className="no-record-ellipse"
          cx="70"
          cy="110"
          rx="40"
          ry="10"
          fill="#f3e6f7"
        />
        <rect
          x="40"
          y="40"
          width="60"
          height="40"
          rx="8"
          fill="#fff"
          stroke="#af3585"
          strokeWidth="2"
        />
        <rect
          x="50"
          y="50"
          width="40"
          height="6"
          rx="3"
          fill="#f3e6f7"
          className="no-record-bar"
        />
        <rect
          x="50"
          y="60"
          width="30"
          height="6"
          rx="3"
          fill="#f3e6f7"
          className="no-record-bar"
        />
        <g className="no-record-magnifier">
          <circle cx="100" cy="90" r="10" stroke="#af3585" strokeWidth="2" fill="#fff" />
          <line x1="106" y1="96" x2="112" y2="102" stroke="#af3585" strokeWidth="2" strokeLinecap="round" />
          <line x1="96" y1="86" x2="104" y2="94" stroke="#af3585" strokeWidth="2" strokeLinecap="round" opacity="0.2" />
        </g>
      </svg>
    </div>
    <div className="no-record-message">{message}</div>
  </div>
);

export default NoRecordFound;